/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import styled from "styled-components";
import MuiContainer from "@material-ui/core/Container";
import MuiButton from "@material-ui/core/Button";
import { NAVBAR_HEIGHT } from "../constants";
import { useConfig } from "../config/configContext";

const LightAppBar = styled.div`
  background: white;
  color: black;
`;

const DarkAppBar = styled.div`
  background: ${(props) => props.theme.palette.primary.main};
  color: white;
`;

const Container = styled(MuiContainer)`
  position: relative;
  height: ${NAVBAR_HEIGHT};
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

const Logo = styled.img`
  position: relative;
  top: -2px;
  height: 50px;
  width: auto;
`;

const Button = styled(MuiButton)`
  text-transform: none;

  @media screen and (max-width: 480px) {
    font-size: 0.8rem;
    line-height: 1.4;
    text-align: center;
  }
`;

export const NavBar = () => {
  const { content, lightAppBar } = useConfig();
  const AppBar = lightAppBar === true ? LightAppBar : DarkAppBar;

  return (
    <AppBar>
      <Container position="static" maxWidth={false}>
        <Logo src={content.logo} />
        <Button color="inherit" href={content.mainSite.url}>
          Return to main website
        </Button>
      </Container>
    </AppBar>
  );
};
